<template>
  <div class="container">
    <div class="row">
      <div class="col-12 offset-lg-2 col-lg-8">
        <page-content ref="pageContent" :organizations="organizations" :viewingEvents="viewingEvents" :isEmptyCartPhotos="isEmptyCartPhotos" pageType="Organization"></page-content>

        <!-- フォーム送信UI -->
        <div class="row text-center">
          <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
            <div class="my-4">
              <h3 class="h6 font-size-1 mb-1">
                <trans-text i18nKey="ui['5_1'][13]"/>
              </h3>
              <button id="BtnAddSchoolCode" type="button" class="btn-add-school-code btn w-100 btn-lg btn-danger" ref="toggleShoolCodePopoverFormBtn" @click="toggleShoolCodePopoverForm"><trans-text i18nKey="ui['5_1'][14]"/></button>
            </div>
          </div>
        </div>
      </div>
      <add-school-code-popover v-show="isShowShoolCodePopoverForm" ref="shoolCodePopoverForm" @fetchOrganization="fetchOrganization"></add-school-code-popover>
      <add-event-key-popover v-show="isShowEventKeyPopoverForm" ref="eventKeyPopoverForm" @fetchOrganization="fetchOrganization" :provisionalRouteTo="provisionalRouteTo"></add-event-key-popover>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import PageContent from 'page/partials/MyPage/EventInfo/PageContent.vue'
  import AddSchoolCodePopover from 'components/popover/AddSchoolCodePopover.vue'
  import AddEventKeyPopover from 'components/popover/AddEventKeyPopover.vue'

  import Organization from 'processor/Organization'
  import Event from 'processor/Event'

  /** @name page_subPages_MyPage_Event_Organization */
  export default {
    name:"",
    components: {
      PageContent,
      AddSchoolCodePopover,
      AddEventKeyPopover
    },
    props:["organizations","viewingEvents","isEmptyCartPhotos"],
    data () {
      return {
        provisionalRouteTo:{},
        isShowEventKeyPopoverForm:false,
        isShowShoolCodePopoverForm:false,
      }
    },
    created(){
    },
    mounted(){
    },
    beforeRouteLeave (to, from, next) {

      if(to.name === "mypage::event::catalog") { //clickイベントから発火したcheckEventActivatedで判定
        return Event.isEventActivated({"event_id": to.params.event_id})
          .then((res) => {
            if (res.status === "ng") {
              this.apiErrorI18nKey = res.apiErrorI18nKey
              return
            }
            //イベントがアクティブでない
            if (!res.data.is_activated) {
              this.isShowEventKeyPopoverForm = !this.isShowEventKeyPopoverForm
              this.$nextTick(function () {
                new Tether({
                  element: this.$refs.eventKeyPopoverForm.$refs.popover,
                  target: this.$refs.pageContent.$refs["linkOrderCatalog"+to.params.event_id][0].$el,
                  attachment: 'top right',
                  targetAttachment: 'bottom right',
                });
              })
              this.provisionalRouteTo = to
              return
            }
            this.isShowShoolCodePopoverForm=false
            this.isShowEventKeyPopoverForm=false
            this.$nextTick(function () {
              next()
            })
          })
      }
      this.isShowShoolCodePopoverForm=false
      this.isShowEventKeyPopoverForm=false
      this.$nextTick(function () {
        next()
      })

    },
    watch:{
      '$route' (to, from) {
        this.isShowShoolCodePopoverForm=false
        this.isShowEventKeyPopoverForm=false
      }
    },
    methods:{
//      checkEventActivated(event){
//        Event.isEventActivated({"event_id": this.provisionalRouteTo.params.event_id})
//          .then((res) => {
//            if (res.status === "ng") {
//              this.apiErrorI18nKey = res.apiErrorI18nKey
//              return
//            }
//            //イベントがアクティブでない
//            if (!res.data.is_activated) {
//              this.isShowEventKeyPopoverForm = !this.isShowEventKeyPopoverForm
//              this.$nextTick(function () {
//                new Tether({
//                  element: this.$refs.eventKeyPopoverForm.$refs.popover,
//                  target: event.target,
//                  attachment: 'top center',
//                  targetAttachment: 'bottom center',
//                });
//              })
//              return
//            }
//
//            this.$router.push({ name: 'user', params: { userId: 123 }})
//            //this.$router.push({ name: 'mypage::event::catalog', params: { event_id: this.provisionalRouteTo.params.event_id }})
//
////            this.$nextTick(function () {
////              this.$router.push({ name: 'mypage::event::catalog', params: { event_id: this.provisionalRouteTo.params.event_id }})
////              return
////            })
//          })
//      },
      fetchOrganization(){
        this.isShowShoolCodePopoverForm=false
        this.isShowEventKeyPopoverForm=false
        this.$emit('fetchOrganization')
      },
      toggleShoolCodePopoverForm(){
        this.isShowShoolCodePopoverForm = !this.isShowShoolCodePopoverForm
        this.$nextTick(function () {
          new Tether({
            element: this.$refs.shoolCodePopoverForm.$refs.popover,
            target: this.$refs.toggleShoolCodePopoverFormBtn,
            attachment: 'top center',
            targetAttachment: 'bottom center',
          });
        })
        if(this.isShowShoolCodePopoverForm){
            dd($("#BtnAddSchoolCode"))
          $("html,body").animate({scrollTop:$("#BtnAddSchoolCode").offset().top});
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .btn-add-school-code{
    position: relative;
    &:before{
      font-family: FontAwesome;
      content: '\f271';
      font-size:1.2rem;
      color: #fff;
      position: absolute;
      top: 50%;
      transform: translateY(-50%) translateX(0);
      left: 5%;
    }
  }
</style>



// WEBPACK FOOTER //
// Organization.vue?90e40710